import { LienDeNavigation } from './LienDeNavigation';
import { ADRESSE_EMAIL, lAdresseEstOuverte } from '../contact-du-groupe';
import { LES_HUIT_PAGES } from '../les-huit-pages';

/**
 * **Le pied de page, et il porte TROIS choses — F-69, liste fermée.**
 *
 * « **Le pied de page porte le chemin vers la page juridique, la page du groupe et l'adresse
 * email affichée. Il ne porte pas le carrousel.** »
 *
 * **La dernière phrase est une interdiction, et elle a un motif** : F-70 pose que « le
 * carrousel vit sur l'accueil, et sur cette page seule. **Aucun bandeau, aucun pied de page
 * ne le répète.** » Un pied qui porterait les logos des clientes les afficherait sur **les
 * huit pages**, y compris sur celle de la connexion — donc sur la seule page du produit
 * qu'un élève mineur traverse.
 *
 * **L'adresse email est affichée telle quelle, et son absence se dit.** Voir
 * `features/contact/contact.ts` : le prérequis 22 est ouvert, et « le nom de la boîte se pose
 * au versement ». Inventer une adresse ferait écrire des gens dans le vide.
 */
export function PiedDePage() {
  const pied = LES_HUIT_PAGES.filter((page) => page.pied !== undefined);

  return (
    <footer className="border-t border-bord bg-fond-surface px-6 py-8">
      <div className="mx-auto flex max-w-espace flex-col gap-4">
        {/* **`-ml-3` compense le remplissage de la cible tactile**, et c'est le seul motif :
            `LienDeNavigation` porte `px-3` pour que la zone cliquable atteigne les 44 points
            de la charte. Dans le bandeau, la marque du produit absorbe ce décalage ; ici les
            liens sont **le premier élément de la colonne**, et leur texte se retrouvait
            décalé de douze points par rapport à l'adresse email juste en dessous. Constaté à
            l'écran. */}
        <nav className="-ml-3 flex flex-wrap items-center gap-1">
          {pied.map((page) => (
            <LienDeNavigation key={page.adresse} vers={page.adresse}>
              {page.pied}
            </LienDeNavigation>
          ))}
        </nav>

        {!lAdresseEstOuverte() ? (
          // **On ne montre pas une adresse qu'on n'a pas.** Prérequis 22, ouvert.
          <p className="text-14 text-texte-faible">
            L’adresse de contact du groupe n’est pas encore ouverte.
          </p>
        ) : (
          <a
            href={`mailto:${ADRESSE_EMAIL}`}
            className="text-14 font-weight-700 text-action underline underline-offset-2"
          >
            {ADRESSE_EMAIL}
          </a>
        )}

        {/* **Swype se vend aux structures, jamais aux familles**, et le pied de page est le
            seul endroit du site où cette phrase tient sans occuper une section. `CDC-6` §1 :
            « Swype se vend aux structures de soutien scolaire et aux tuteurs indépendants,
            **jamais aux familles**. » Et **aucun tarif nulle part sur le site** (F-69) : le
            pied n'en porte donc pas, et n'annonce aucun essai gratuit. */}
        <p className="text-13 text-texte-inactif">
          Swype est vendu aux structures de soutien scolaire et aux tuteurs
          indépendants. Les familles n’ont rien à y payer.
        </p>

        {/* Le renvoi juridique est déjà dans la navigation ci-dessus ; cette ligne ne le
            double pas, elle porte la mention de propriété. */}
        <p className="text-13 text-texte-inactif">Groupe Trousseau</p>
      </div>
    </footer>
  );
}
